import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  PredefinedMessage,
  PredefinedMessageApiResponse,
  PredefinedMessageFormValues,
} from '@/types/predefined-messages';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import {
  mapPredefinedMessage,
  mapPredefinedMessageFormValuesToApiPayload,
  PREDEFINED_MESSAGES_QUERY_KEY,
} from '@/hooks/api/use-predefined-message-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

export function useCreatePredefinedMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (values: PredefinedMessageFormValues): Promise<PredefinedMessage> => {
      const payload = mapPredefinedMessageFormValuesToApiPayload(values);
      const { data } = await httpClient.post<PredefinedMessageApiResponse>(
        API_ROUTES.predefinedMessages.list,
        payload
      );

      return mapPredefinedMessage(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
    },
  });
}
